import React from "react";
import { MessageCircle, Check } from "lucide-react";
import { buildWaLink, FAMILIES_ABROAD_MESSAGE, trackWhatsApp } from "@/lib/services";

const IMG = "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?fm=jpg&q=85&w=1200&auto=format&fit=crop";

const bullets = [
  "Regular nurse visits with BP, sugar and vitals",
  "Medication management and reminders",
  "12-hour or 24-hour caretaker at home",
  "WhatsApp update to family after every visit",
  "Book and coordinate everything remotely",
  "Doctor and lab tests arranged at home when needed",
];

export default function FamiliesAbroad() {
  return (
    <section data-testid="abroad-section" id="for-families-abroad" className="py-16 md:py-24 bg-bone">
      <div className="container-x grid grid-cols-12 gap-10 items-center">
        <div className="col-span-12 lg:col-span-6 order-2 lg:order-1">
          <div className="text-[13px] font-bold uppercase tracking-widest text-brand">For Families Abroad</div>
          <h2 className="mt-3 text-[32px] md:text-[44px] font-extrabold text-navy leading-[1.1]">
            Living away from your parents? <span className="text-brand">We're right here for them.</span>
          </h2>
          <p className="mt-4 text-ink/85 max-w-xl">
            Whether you're in Bangalore for work or in another country entirely, we can be your eyes and ears at your parents' home — with the kind of regular, warm, trained care that makes you sleep easier at night.
          </p>

          <ul className="mt-6 grid sm:grid-cols-2 gap-3">
            {bullets.map((b) => (
              <li key={b} className="flex items-start gap-2 text-[15.5px] text-ink/90">
                <span className="shrink-0 w-5 h-5 rounded-full bg-care text-white flex items-center justify-center mt-0.5"><Check className="w-3.5 h-3.5" /></span>
                {b}
              </li>
            ))}
          </ul>

          <div className="mt-7">
            <a
              data-testid="abroad-wa-btn"
              href={buildWaLink(FAMILIES_ABROAD_MESSAGE)}
              target="_blank" rel="noopener noreferrer"
              onClick={() => trackWhatsApp("For Families Abroad")}
              className="btn-wa"
            >
              <MessageCircle className="w-5 h-5" /> Talk to us on WhatsApp
            </a>
          </div>
        </div>

        <div className="col-span-12 lg:col-span-6 order-1 lg:order-2">
          <div className="aspect-[5/4] rounded-3xl overflow-hidden shadow-card bg-soft-blue">
            <img src={IMG} alt="Elderly parent in Bangalore on a video call with their child abroad" loading="lazy" className="w-full h-full object-cover" />
          </div>
        </div>
      </div>
    </section>
  );
}
